// Checking ios safari
export const isSafari = () => {
    const result =
        window.navigator.userAgent.match(/(iPod|iPhone|iPad|Macintosh)/)
        && window.navigator.userAgent.match(/AppleWebKit/);
    return result;
}

export const safariIosVersion = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (
        userAgent.indexOf("iphone os") > -1 &&
        userAgent.indexOf("safari") > -1 &&
        !(userAgent.indexOf("chrome") > -1)
    ) {
        return /iphone os\ ([\d]+)/i.exec(userAgent)[1];
    } else {
        return null;
    }
};

/**
 * Determine whether is chrome
 *
 * @returns {String}
 */
export const isChrome = () => {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
}

/**
 * Get Chrome version
 *
 * @returns {String}
 */
function chromeVersion() {     
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return raw ? parseInt(raw[2], 10) : false;
}

/**
 * Determine whether is andriod
 *
 * @returns {String}
 */
export const isAndroid = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android/i.test(userAgent);   
}

/**
 * Determine whether is ios and above version
 *
 * @returns {String}
 */
export const isIOS = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream);
}

/**
 * Determine whether is supported browser and version
 *
 * @returns {String}
 */
export const detectBrowserVersion = () => {
    const iosV = safariIosVersion();
    return ((isAndroid && isChrome && chromeVersion && chromeVersion >= 70) || (isIOS && (isSafari || isChrome) && iosV && iosV >= 12));
}


/**
 * Determine whether is supported browser (chrome and safari)
 *
 * @returns {String}
 */
export const detectBrowser = () => {
    return isSafari() || isChrome()
}